import { render, staticRenderFns } from "./presentation-sidebar.vue?vue&type=template&id=5827a0bd&scoped=true&"
import script from "./presentation-sidebar.vue?vue&type=script&lang=js&"
export * from "./presentation-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./presentation-sidebar.vue?vue&type=style&index=0&id=5827a0bd&scoped=true&lang=css&"
import style1 from "./presentation-sidebar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827a0bd",
  null
  
)

export default component.exports